<template>
    <v-card>

        <v-card-title>
            Issue Timeline
            <div class="flex-grow-1"></div>
            <v-btn class="reverse-button" icon @click="reverseOrder"><v-icon large>mdi-swap-vertical-circle-outline</v-icon></v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text style="height: 100%;">

            <div class="timeline-container" v-if="showTimeline">
                <v-timeline class="timeline" align-top>

                    <v-timeline-item v-for="(item, index) in timelineObjs" :key="index" :color="item.color">
                        <template v-slot:icon>
                            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" v-if="item.actionIcon.includes('mdi-')">{{item.actionIcon}}</v-icon>
                                    <span v-on="on" style="color: #ffffff; font-weight: bold;" v-else>{{item.actionIcon}}</span>
                                </template>
                                <span>{{item.actionHoverHelp}}</span>
                            </v-tooltip>
                        </template>

                        <v-card :color="item.color" dark>
                            <v-card-title class="card-title">

                                <v-avatar class="username-avatar mr-2">
                                    <img :src="getUserImage(item)" v-if="getUserImage(item)" />
                                    <v-icon class="mr-2" large v-else>{{getAvatarIcon(item)}}</v-icon>    
                                </v-avatar>

                                <!-- <v-icon class="mr-2" large v-else>mdi-server</v-icon> -->
                                <!-- mdi-account-circle -->

                                <div class="title-section">
                                    <span class="time">{{item.timestamp}}</span>
                                    <span class="username">{{item.username}}</span>
                                    <span class="alarm-index" v-text="`${item.order}/${timelineObjs.length}`" />
                                </div>
                            </v-card-title>

                            <v-card-text class="white text--primary">
                                <span style="display: block; padding-top: 10px; color: #000000;">{{item.text}}</span>
                            </v-card-text>
                        </v-card>
                    </v-timeline-item>

                </v-timeline>
            </div>

        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('close')">Close</v-btn>
        </v-card-actions>

    </v-card>
</template>

<script>
export default {
    name: 'IssueTimeline',
    props: ['remarks', 'history'],
    components: {

    },
    data: () => ({
        showTimeline: false,
        timelineObjs: [],
        sortBy: 'asc'
    }),

    computed: {

    },

    methods: {
        buildTimeline: function() {
            let remarks = this.$props.remarks;
            let remarkObjs = [];
            let histories = this.$props.history;
            let historyObjs = [];

            for(let remark of remarks) {
                remarkObjs.push({
                    type: 'remark',
                    color: '#66BB6A',
                    actionIcon: 'mdi-message-text',
                    actionHoverHelp: 'Remark Added',
                    text: remark.issue_action_details,
                    username: remark.username,
                    timestamp: remark.issue_action_timestamp,
                    unix: TELSA.moment(remark.issue_action_timestamp).unix()
                });
            }

            for(let history of histories) {
                historyObjs.push({
                    type: 'history',
                    color: '#3F51B5',
                    actionIcon: 'mdi-history',
                    actionHoverHelp: 'History Updated',
                    username: history.username,
                    timestamp: history.issue_action_timestamp,
                    text: history.issue_action_details,
                    unix: TELSA.moment(history.issue_action_timestamp).unix()
                });
            }
            
            this.timelineObjs = remarkObjs.concat(historyObjs);
            this.timelineObjs.sort((a,b) => a.unix - b.unix);
            for(let [idx, timelineObj] of this.timelineObjs.entries()) {
                timelineObj.order = idx + 1;
            }
            this.showTimeline = true;
        },

        getUserImage: function(item) {
            let user = this.$store.state.batchConfig.users.find(u => u.user_username == item.username);
            return user ? user.userImage : null;
        },

        getAvatarIcon: function(item) {
            return item.username == 'SYSTEM' ? 'mdi-server' : 'mdi-account-circle';
        },

        reverseOrder: function() {
            if(this.sortBy == 'asc') {
                this.sortBy = 'desc';
                this.timelineObjs.sort((a,b) => b.unix - a.unix);
            }
            else {
                this.sortBy = 'asc';
                this.timelineObjs.sort((a,b) => a.unix - b.unix);
            }
        }
    },

    mounted() {
        this.buildTimeline();
    }

  
};
</script>

<style scoped>

    .reverse-button {
        /* position: absolute; */
        /* float: right;
        display: inline-block; */
    }

    .timeline-container {
        position: relative;
        padding: 10px;
        display: inline-block;
        width: 100%;
        /* height: calc(100vh - 260px); */
        
    }

    .timeline {
        position: relative;
        overflow-y: auto;
    }

    .card-title {
        padding: 7px;
    }

    .username-avatar {
        height: 36px !important;
        min-width: 36px !important;
        width: 36px !important;
        display: inline-block;
    }

    .title-section {
        position: relative;
        display: inline-block;
        line-height: 16px;
        margin-top: 4px;
        width: calc(100% - 45px);
    }

    .title-section .time {
        display: block;
    }
    .title-section .username {
        display: inline-block;
        font-size: 15px;
    }
    .title-section .cloud {
        display: inline-block;
        font-size: 15px;
        margin-left: 5px;
        vertical-align: bottom;
    }
    .title-section .alarm-index {
        float: right;
        font-size: 16px;
    }

</style>
